module.exports = __webpack_public_path__ + "img/Expo-Kc-Clarity-and-confidence.0090b38f.png";